export const modalSizes = {
  sm: '330px',
  md: '420px',
  base: '520px',
  lg: '750px',
  xl: '975px',
  margin: '20', // px
};
